import axios from 'axios';

import type { identifier } from '@core/models/base';
import type {
  AvailableImageServiceTypeDisplayModel,
  CartImageServiceSelectionCreateModel,
  CartImageServiceSelectionDisplayModel,
} from '@shared/models/images/imageServices';

export const fetchAvailableImageServices = async (jobId: identifier) =>
  (
    await axios.get<AvailableImageServiceTypeDisplayModel[]>(
      `/api/customer/jobs/${jobId}/cartImageServiceSelections/available`,
    )
  ).data;

export const fetchCartImageServiceSelections = async (jobId: identifier) =>
  (await axios.get<CartImageServiceSelectionDisplayModel[]>(`/api/customer/jobs/${jobId}/cartImageServiceSelections`))
    .data;

export const upsertCartImageServiceSelections = async (
  jobId: identifier,
  selections: CartImageServiceSelectionCreateModel[],
) =>
  (
    await axios.post<CartImageServiceSelectionDisplayModel[]>(
      `/api/customer/jobs/${jobId}/cartImageServiceSelections`,
      selections,
    )
  ).data;

export const deleteCartImageServiceSelection = async (jobId: identifier, selectionId: identifier) =>
  await axios.delete(`/api/customer/jobs/${jobId}/cartImageServiceSelections/${selectionId}`);
